import DOMPurify from 'dompurify';
import { useRef, useMemo, useCallback } from 'react';
import ReactQuill from 'react-quill';
import { FormCard } from '../../shared/FormCard';
import { getErrorStyle } from '../../shared/utils';
import { jobDescriptionMinLength } from '../../shared/constants';

export const JobDescriptionCard = ({ formValues, handleChange, errorStatus }) => {
  const quillRef = useRef(null);
  const timeoutRef = useRef(null);

  const modules = useMemo(
    () => ({
      toolbar: [['bold', 'italic']],
    }),
    [],
  );

  const handleTextChanged = useCallback(
    (content, delta, source, editor) => {
      // Clear previous timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Debounce the state update to avoid cursor position issues
      timeoutRef.current = setTimeout(() => {
        const sanitizedContent = DOMPurify.sanitize(content);
        const plainText = editor.getText().trim();
        handleChange(sanitizedContent, plainText);
      }, 100);
    },
    [handleChange],
  );

  return (
    <FormCard
      title="Job Description"
      required
      style={{ marginTop: 16 }}
      contentStyle={{ width: '80%', gap: 10 }}
    >
      <ReactQuill
        ref={quillRef}
        value={formValues.jobDescription.raw}
        onChange={handleTextChanged}
        theme="snow"
        style={{ ...getErrorStyle(errorStatus?.invalidJobDescription) }}
        placeholder="Job Description"
        modules={modules}
      />
      <span style={{ color: '#999999' }}>{jobDescriptionMinLength} Character Min</span>
    </FormCard>
  );
};
